export default "__VITE_ASSET__FuC74phs__"